
jQuery(document).ready(function() {

    if(jQuery('.page-template-template-accueil').length) {

        var bouton_equipe = jQuery('#equipe .rond_bouton');
        var window_height = jQuery(window).height();
        var offset_top_equipe_full = jQuery('section#equipe').offset().top;
        var offset_bottom_equipe_full = offset_top_equipe_full + jQuery('section#equipe').outerHeight();

        // Manage mouse enter & leave
        // jQuery('section#equipe .photo_container').mouseover(function () { 
        //     bouton_equipe.addClass('in_zone');
        // });
        // jQuery('section#equipe .photo_container').mouseleave(function () { 
        //     bouton_equipe.removeClass('in_zone');
        // });

        jQuery('section#equipe').on({
            mouseenter: function () {
                bouton_equipe.addClass('in_zone');
            },
            mouseleave: function () {
                bouton_equipe.removeClass('in_zone');
            }
        }, '.photo_container');

        // Manage when mouse enters on scroll
        document.addEventListener('windowScroll', (e) => {
            // console.log('offset_top_equipe_full : '+offset_top_equipe_full);
            // console.log('offset_bottom_equipe_full : '+offset_bottom_equipe_full);
            // console.log('current_scroll : '+current_scroll);
            if(offset_top_equipe_full < current_scroll+window_height && offset_bottom_equipe_full > current_scroll) {
                
                var hovered_element = document.elementFromPoint(xMouse, yMouse);

                if(hovered_element.className !== null) {
                    var classes = hovered_element.className;
                    if(classes.includes('photo')) {
                        bouton_equipe.addClass('in_zone');
                    } else {
                        bouton_equipe.removeClass('in_zone');
                    }
                }
            }
            
        });
        
        // ON RESIZE, UPDATE STATIC INFOS
        document.addEventListener('windowresize', (e) => {
            var window_height = jQuery(window).height();
            var offset_top_equipe_full = jQuery('section#equipe').offset().top;
            var offset_bottom_equipe_full = offset_top_equipe_full + jQuery('section#equipe').outerHeight();
        }, false);

    }
});